import { makeStyles } from "@material-ui/core/styles";
import { secondary, white } from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  content: {
    color: secondary,
    "& label": {
      cursor: "pointer",
    },
    "& span > svg": {
      width: theme.spacing(2),
      marginRight: theme.spacing(1),
    },
    "&:hover": {
      backgroundColor: white,
    },
  },
  circular: {
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
